<mat-card class="account-card plan">
  <span class="activity-card-title">
    <span class="mat-headline-6"
      >{{ "ONSIP_I18N.PBX_OVERVIEW.PLAN_INFORMATION" | translate }}
    </span>
    <button
      mat-icon-button
      color="primary"
      [routerLink]="views.ADMIN_ACCOUNT_SETTINGS_PLAN_OVERVIEW"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </span>
  <div class="account-info">
    <div class="mat-headline-5">{{ currentPlan$ | async }}</div>
    <mat-divider class="divider"></mat-divider>
    <div class="mat-caption">
      {{ monthCost$ | async }}
      {{ monthCostText$ | async }}
    </div>
  </div>
</mat-card>
<mat-card class="account-card balance">
  <span class="activity-card-title">
    <span class="mat-headline-6 activity-card-title"
      >{{ "ONSIP_I18N.PBX_OVERVIEW.ACCOUNT_BALANCE" | translate }}
    </span>
    <button
      mat-icon-button
      color="primary"
      [routerLink]="views.ADMIN_ACCOUNT_SETTINGS_PLAN_OVERVIEW"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </span>
  <div class="account-info">
    <div class="mat-headline-5">
      {{ accountBalance$ | async }}
    </div>
    <mat-divider class="divider"></mat-divider>
    <span class="mat-caption semi-bold">
      {{ "ONSIP_I18N.PBX_OVERVIEW.NEXT_PAYMENT_DUE" | translate }}:
      {{ (accountPaymentDate$ | async) ? (accountPaymentDate$ | async | date) : "n/a" }}
    </span>
  </div>
</mat-card>

<mat-card class="account-card credit">
  <span class="activity-card-title">
    <span class="mat-headline-6 activity-card-title"
      >{{ "ONSIP_I18N.PBX_OVERVIEW.CALLING_CREDITS" | translate }}
    </span>
    <button
      mat-icon-button
      color="primary"
      [routerLink]="views.ADMIN_ACCOUNT_SETTINGS_CALLING_CREDITS"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </span>
  <div class="account-info">
    <div
      class="mat-headline-5"
      [ngClass]="{ 'account-info_negative': isNegativeAccountPSTNCredit$ | async }"
    >
      {{ accountPSTNCredit$ | async }}
    </div>
    <mat-divider class="divider"></mat-divider>

    <span class="mat-caption semi-bold">
      {{ "ONSIP_I18N.AUTO_REFILL" | translate }}:
      {{ ((enableAutoRefill$ | async) ? "ONSIP_I18N.ENABLED" : "ONSIP_I18N.DISABLED") | translate }}
    </span>
  </div>
</mat-card>
